import { isFullCanvasVisibility } from "../../common/canvasUrlParams";

export function isDevEnvironment() {
  return process.env.REACT_APP_ENVIRONMENT === "dev";
}

export function isStagingEnvironment() {
  return process.env.REACT_APP_ENVIRONMENT === "test";
}

export function showLimitedView() {
  return !isFullCanvasVisibility(window.location.search);
}

export function isGoogleLoginUser() {
  return localStorage.getItem("authProvider") === "google";
}
